import { useState, useEffect, useMemo } from 'react';
import { useMedia as useReactMedia } from 'react-use';
import { useWindowSize } from 'utils/hooks';

type Media = 'largeDesktop' | 'desktop' | 'phone';

const basicWidth = parseInt(process.env.BASIC_WIDTH || '1700', 10);

const useMedia = () => {
    const matchLargetDesktop = useReactMedia('(min-width: 1701px)');
    const matchDesktop = useReactMedia('(min-width: 900px) and (max-width: 1700px)');
    const matchPhone = useReactMedia('(max-width: 899px)');

    const { width: windowW } = useWindowSize();

    const [media, updateMedia] = useState<Media>('desktop');

    const mediaScale = useMemo<number>(() => {
        return media === 'largeDesktop' ? windowW / basicWidth : 1;
    }, [media, windowW]);

    useEffect(() => {
        if (matchLargetDesktop) {
            updateMedia('largeDesktop');
        } else if (matchDesktop) {
            updateMedia('desktop');
        } else if (matchPhone) {
            updateMedia('phone');
        }
    }, [matchDesktop, matchPhone]);

    return { media, mediaScale };
};

export default useMedia;
